import { CampaignAttributes } from 'portal-commons';
import { FC } from 'react';

import { Section, SectionContent, SectionTitle } from './atoms';
import { CampaignDetail } from '@/apis/core';

interface ProgramAttributesSectoinProps {
  campaign: CampaignDetail;
}

const getDisabledOption = (checked: boolean) => (checked ? 'no' : 'yes');

const ProgramAttributesSection: FC<ProgramAttributesSectoinProps> = ({
  campaign,
}) => {
  return (
    <Section>
      <SectionTitle>Program Attributes</SectionTitle>
      <SectionContent columns={2}>
        <CampaignAttributes.Attribute
          readonly
          label="Embedded Link"
          tooltip="Indicates whether the program is using an embedded link of any kind. Note that public URL shorteners (bitly, tinyurl) are not accepted"
          disabledOption={getDisabledOption(campaign.embeddedLink)}
          value={campaign.embeddedLink}
          additionalSetup={
            <CampaignAttributes.AttributePopupContainer tooltip="A field for an embedded link sample.">
              {campaign.embeddedLinkSample}
            </CampaignAttributes.AttributePopupContainer>
          }
        />
        <CampaignAttributes.Attribute
          readonly
          label="Embedded Phone Number"
          tooltip="Indicates whether the program is using an embedded phone number (except the required HELP information contact phone number)"
          disabledOption={getDisabledOption(campaign.embeddedPhone)}
          value={campaign.embeddedPhone}
        />
      </SectionContent>
    </Section>
  );
};

export default ProgramAttributesSection;
